<div class="error-page">
    <span><img src="../../../../assets/images/404.svg" /></span>
    <h1 class="display-4 error-message">Page Not Found</h1>
    <p>Unfortunately, the requested page could not be found.</p>
    <a (click)="goBack()">Go Back</a>
</div>
